import React, { ReactElement } from 'react';
import { useDropzone } from 'react-dropzone';

const typeToClass = {
  compact: 'file-input file-input-compact h-100 bg-lvl1',
  small: 'file-input file-input-md h-100 bg-lvl1',
  medium: 'file-input file-input-lg h-100 bg-lvl1',
  large: 'file-input file-input-xl h-100 bg-lvl1',
};

const typeToShowTitle = {
  compact: false,
  small: false,
  medium: true,
  large: true,
};

const typeToShowBrowseButton = {
  compact: false,
  small: false,
  medium: false,
  large: true,
};

export interface DsDropZoneProps {
  onSelectedFiles: (files: File[]) => void;
  type?: 'small' | 'medium' | 'large' | 'compact';
  addLabel?: string;
  dragLabel?: string;
  selectLabel?: string;
  fileLabel?: string;
  browseLabel?: string;
}

export const DsDropZone: React.FC<DsDropZoneProps> = ({
  onSelectedFiles,
  type = 'large',
  addLabel = 'Add attachment',
  dragLabel = 'Drag or',
  selectLabel = 'select',
  fileLabel = 'your file to this area to upload',
  browseLabel = 'Browse file',
}): ReactElement => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => onSelectedFiles(files),
  });

  const className = typeToClass[type];
  const showTitle = typeToShowTitle[type];
  const showBrowseButton = typeToShowBrowseButton[type];

  return (
    <div className={className} {...getRootProps({ onClick: (evt) => evt.preventDefault() })}>
      <div className="file-input-corners"></div>
      <em className="file-input-icon icon icon-xl">attach_file</em>
      {showTitle && <h4 className="file-input-title">{addLabel}</h4>}
      <p className="file-input-text">
        {dragLabel}{' '}
        <label htmlFor="fileInput" className="file-input-link" style={{ cursor: 'pointer' }}>
          {selectLabel}
        </label>{' '}
        {fileLabel}
      </p>
      {showBrowseButton && (
        <label htmlFor="fileInput" className="btn btn-discreet-secondary file-input-button" style={{ cursor: 'pointer' }}>
          {browseLabel}
        </label>
      )}
      <input className="d-none" type="file" name="fileInput" id="fileInput" {...getInputProps()} />
      <div className="file-input-corners"></div>
    </div>
  );
};
